module.exports = __webpack_public_path__ + "static/img/move-success.88036ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/move-success.png
// module id = zjVJ
// module chunks = 0